<template>
  <el-dialog :title="$t('material.showSettlementUnitDialog')" :visible="isShow" width="65%" @close="cancel('showSettlementUnitDialog')">
    <div>
      <el-form :model="queryCondition" ref="queryCondition" label-width="140px">
        <el-row>
          <el-col :span="9">
            <el-form-item :label="$t('material.settlementUnitCode')" prop="supplierCode">
              <el-input v-model.trim="queryCondition.supplierCode" clearable></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="9">
            <el-form-item :label="$t('material.settlementUnitName')" prop="supplierName">
              <el-input v-model="queryCondition.supplierName" clearable></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row type="flex" justify="center">
          <el-col :span="4">
            <el-button @click="queryData(1)" type="primary">{{$t('common.search')}}</el-button>
            <el-button @click="restQueryForm" type="primary">{{$t('common.reset')}}</el-button>
          </el-col>
        </el-row>
      </el-form>
      <div style="padding-bottom: 15px;"></div>
      <el-table :data="tableList" ref="tableList" border highlight-current-row max-height="420">
        <el-table-column align="center" width="56" :label="$t('common.select')">
          <template slot-scope="scope">
            <el-radio v-model="radioVal" :label="scope.row.tmSupplierId">&nbsp;</el-radio>
          </template>
        </el-table-column>
        <el-table-column prop="supplierCode" :label="$t('material.settlementUnitCode')" min-width="120"></el-table-column>
        <el-table-column prop="supplierName" :label="$t('material.settlementUnitName')" min-width="140"></el-table-column>
      </el-table>
      <div class="pagination">
        <el-pagination @size-change="pageSizeChange" @current-change="pageNumberChange" :current-page="queryCondition.pageNum" :page-sizes="pageSizeList" :page-size="queryCondition.pageSize" :layout="pageLayout" :total="totalCount"></el-pagination>
      </div>
      <div class="foot-btn" style="padding-top: 10px;text-align: center">
        <el-button type="primary" @click="confirmMethod">{{ $t('common.confirm') }}</el-button>
        <el-button @click="cancel('showSettlementUnitDialog')">{{ $t('common.cancel') }}</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import IcSelect from "@/components/common/icSelect";
import commonFunction from "@/utils/dataTableUtils";
import { apiService } from "@/api/material/material-master-data";

export default {
  extends: commonFunction,
  components: {
    IcSelect
  },
  props: {
    isShow: {
      type: Boolean,
      default: true
    },
    createFun: {
      type: Function,
      default: function () {
      }
    }
  },
  data() {
    return {
      queryCondition: {
        pageNum: 1,
        pageSize: 15,
        supplierCode: null,
        supplierName: null,
        scoped:true
      },
      tableList: [],
      totalCount: 0,
      radioVal: null,
    };
  },
  mounted() {
    this.queryData();
  },
  methods: {
    queryData(val) {
      let that = this;
      if (undefined != val) {
        this.queryCondition.pageNum = 1;
      }
      apiService.findSettlementUnitListPage(this.queryCondition).then((res) => {
        that.tableList = res.resultData;
        that.totalCount = res.totalCount;
      });
    },
    // 确认选中
    confirmMethod() {
      if (!!this.radioVal) {
        const changeRow = this.tableList.filter(item => item.tmSupplierId === this.radioVal)
        this.createFun(changeRow[0]);
        this.radioVal = null
      } else {
        this.$message({
          type: "error",
          message: this.$t("common.pleaseSelectData")
        });
      }
    }
  }
};
</script>

<style scoped lang="scss"></style>
